import { NonCachedSearchType } from 'interfaces'

type SearchTermStore = {
  lastNonCachedSearch: NonCachedSearchType
  lastTextSearched: string
  lastInterchangeTextSearched: string
  breadCrumbs: Array<{ breadcumb?: string }>
}

export const getResultsSearchTerm = (searchStore: SearchTermStore): string => {
  const {
    lastNonCachedSearch,
    lastTextSearched,
    lastInterchangeTextSearched,
    breadCrumbs,
  } = searchStore

  if (
    lastNonCachedSearch === NonCachedSearchType.searchByText ||
    lastNonCachedSearch === NonCachedSearchType.searchBySaytCategories
  ) {
    if (lastNonCachedSearch === NonCachedSearchType.searchBySaytCategories) {
      const saytCrumb = [...breadCrumbs]
        .reverse()
        .find((crumb) => crumb.breadcumb)
      if (saytCrumb?.breadcumb) {
        return saytCrumb.breadcumb
      }
    }
    return lastTextSearched
  }

  if (lastNonCachedSearch === NonCachedSearchType.searchByInterchange) {
    return lastInterchangeTextSearched
  }

  const lastCrumb = breadCrumbs[breadCrumbs.length - 1]
  if (lastCrumb?.breadcumb) {
    return lastCrumb.breadcumb
  }

  return ''
}
